export default __webpack_public_path__ + "static/media/plan-icon.8ca2b71e.svg";